export var SalesRepDataActionType;
(function (SalesRepDataActionType) {
    SalesRepDataActionType["BASE_DATA"] = "BASE_DATA";
    SalesRepDataActionType["ORDERS_DATA"] = "ORDERS_DATA";
    SalesRepDataActionType["VIEW_COUPON_DATA"] = "VIEW_COUPON_DATA";
    SalesRepDataActionType["UPDATE_SINGLE_SALES_REP"] = "UPDATE_SINGLE_SALES_REP";
    SalesRepDataActionType["UPDATE_REP_PROFILE"] = "UPDATE_REP_PROFILE";
    SalesRepDataActionType["CUSTOMER_ADDRESS_DATA"] = "ADDRESS";
    SalesRepDataActionType["PRODUCTS_DATA"] = "PRODUCTS_DATA";
    SalesRepDataActionType["DRAFT_ORDER_DATA"] = "DRAFT_ORDER_DATA";
    SalesRepDataActionType["ST_REPORTS_DATA"] = "ST_REPORTS_DATA";
    SalesRepDataActionType["ST_REPORTS_DEFAULT_DATA"] = "ST_REPORTS_DEFAULT_DATA";
    SalesRepDataActionType["ST_REPORTS_ORDERS_CACHE"] = "ST_REPORTS_ORDERS_CACHE";
    SalesRepDataActionType["ST_REPORTS_CLEAR_ORDERS_CACHE"] = "ST_REPORTS_CLEAR_ORDERS_CACHE";
    SalesRepDataActionType["WHOLESALE_PRICE_DATA"] = "WHOLESALE_PRICE_DATA";
    SalesRepDataActionType["RESET_INITIAL_STATE"] = "RESET_INITIAL_STATE";
    SalesRepDataActionType["EDIT_DRAFT_ORDER"] = "EDIT_DRAFT_ORDER";
    SalesRepDataActionType["ACTIVE_TAB"] = "ACTIVE_TAB";
    SalesRepDataActionType["CREATE_ORDER_TAB"] = "CREATE_ORDER_TAB";
    SalesRepDataActionType["CHECKOUT_CONFIRMATION_POPUP"] = "CHECKOUT_CONFIRMATION_POPUP";
    SalesRepDataActionType["CUSTOMER_DETAILS_CREATE_INVOICE"] = "CUSTOMER_DETAILS_CREATE_INVOICE";
    SalesRepDataActionType["LOCATION_PRICELIST_DATA"] = "LOCATION_PRICELIST_DATA";
    SalesRepDataActionType["PRODUCT_TABLE_DATA"] = "PRODUCT_TABLE_DATA";
    SalesRepDataActionType["CART_SHARE_PRODUCT_DATA"] = "CART_SHARE_PRODUCT_DATA";
    SalesRepDataActionType["COLLECTION_PRODUCTS_DATA"] = "COLLECTION_PRODUCTS_DATA";
    SalesRepDataActionType["CUSTOMER_LIST_WITH_MAINCONTACT"] = "CUSTOMER_LIST_WITH_MAINCONTACT";
    SalesRepDataActionType["CATALOG_PRODUCT_LIST"] = "CATALOG_PRODUCT_LIST";
    SalesRepDataActionType["REP_ALL_CUSTOMERS"] = "REP_ALL_CUSTOMERS";
    SalesRepDataActionType["B2B_COMPANIES_DATA"] = "B2B_COMPANIES_DATA";
    SalesRepDataActionType["TERRITORY_REPORT_DATA"] = "TERRITORY_REPORT_DATA";
})(SalesRepDataActionType || (SalesRepDataActionType = {}));
